import { defaultInputProps } from '../../../FormContainer/defaultFormStates';
import {
  getExternalUsers,
  getTrafficSources
} from '../../../common/commonRequests';
import {
  checkAffiliateManager,
  checkAmb
} from '../../../PermissionsWrappers/permissionChecks';

const affiliateType = [
  { value: 'all', display: 'Select Type' },
  { value: '0', display: 'Internal' },
  { value: '1', display: 'External' }
];

const affiliateStatus = [
  { value: 'all', display: 'Select Status' },
  { value: '0', display: 'Inactive' },
  { value: '1', display: 'Active' }
];

const trafficSourceAmb = [{ value: '14', display: 'AMB' }];

export const addAffiliateState = () => ({
  connected_user: {
    ...defaultInputProps,
    name: 'connected_user',
    type: 'select',
    label: 'Connected User',
    options: () => getExternalUsers(),
    value: '0',
    defaultVal: '0'
  },
  affiliate_name: {
    ...defaultInputProps,
    name: 'affiliate_name',
    label: 'Affiliate Name'
  },
  is_external: {
    ...defaultInputProps,
    name: 'is_external',
    type: 'select',
    label: 'Affiliate Type',
    options: () => affiliateType,
    hidden: checkAffiliateManager(),
    value: 'all',
    defaultVal: 'all'
  },
  status: {
    ...defaultInputProps,
    name: 'status',
    type: 'select',
    label: 'Status',
    options: () => affiliateStatus,
    value: 'all',
    defaultVal: 'all'
  },
  traffic_source: {
    ...defaultInputProps,
    name: 'traffic_source',
    type: 'select',
    skipValidation: checkAmb(),
    label: 'Traffic Source',
    defaultVal: checkAmb() ? '14' : '-1',
    value: checkAmb() ? '14' : '-1',
    options: () => (checkAmb() ? trafficSourceAmb : getTrafficSources(true))
  }
});
